module.exports = __webpack_public_path__ + "7197447db790149b256792f096e0da7e.png";